import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Modal from '../../components/helpers/Modal';
import * as selectors from '../../selectors/admin/modal.forms';
import { closeModalForm, onInput } from '../../actions/admin/modal.forms';
import { organizationsOptionsSelector, contextSubjectSelector } from '../../selectors/admin/context';
import LoadingWrapper from '../../components/hocs/LoadingWrapper';
import ModalButtons from '../../components/admin/forms/ModalButtons';
import { LOADING_TEXT } from '../../constants/settings';

class AdminModalForm extends Component {
    componentDidMount() {
        this._fetchDependencies();
    }
    componentDidUpdate() {
        this._fetchDependencies();
    }
    _fetchDependencies() {
        if (
            this.props.open &&
            !this.props.forceClose &&
            !this.props.fetchedDependencies &&
            !this.props.fetchingDependencies &&
            this.props.fetchDependencies
        ) {
            this.props.fetchDependencies(this.props.contextId, this.props.modelId);
        }
    }
    _onInput = (value, field) => this.props.onInput(this.props.model, field, value);
    _onSubmit = () => {
        this.props.data.id
            ? this.props.updateAction(this.props.data, this.props.modelId)
            : this.props.createAction(this.props.data, this.props.modelId);
    };
    render() {
        const Fields = this.props.fields;
        return (
            <Modal
                onClose={this.props.closeModalForm}
                className={'is-big'}
                open={this.props.open && !this.props.forceClose}
            >
                <div className="ckp-admin-modal-forms">
                    <h4 className="ckp-admin-modal-forms-title ckp-ts-h1">{this.props.title}</h4>
                    <LoadingWrapper
                        label={this.props.submitting ? 'Saving...' : LOADING_TEXT}
                        className="is-big"
                        show={this.props.isLoading}
                    >
                        <h4 className="ckp-admin-modal-forms-error">{this.props.error}</h4>
                        <Fields
                            context={this.props.contextId}
                            dependencies={this.props.dependencies}
                            staticData={this.props.staticData}
                            errors={this.props.errors}
                            data={this.props.data}
                            onInput={this._onInput}
                        />
                        <ModalButtons
                            deleteAction={
                                this.props.data.id && this.props.deleteAction
                                    ? () => this.props.deleteAction(this.props.data.id)
                                    : null
                            }
                            cancelAction={this.props.closeModalForm}
                            confirmLabel={this.props.confirmLabel}
                            confirmAction={this._onSubmit}
                            inactive={!this.props.canSubmit}
                        />
                    </LoadingWrapper>
                </div>
            </Modal>
        );
    }
}

const mapStateToProps = (state, props) => ({
    contextId: contextSubjectSelector(state),
    error: selectors.formErrorSelector(state),
    open: selectors.formOpenSelector(state),
    data: selectors.formDataSelector(state, props),
    canSubmit: selectors.canSubmit(state, props),
    submitting: selectors.submittingSelector(state),
    fetchingDependencies: selectors.fetchingDependenciesSelector(state),
    fetchedDependencies: selectors.fetchedDependenciesSelector(state),
    dependencies: selectors.dependenciesSelector(state),
    contextOptions: organizationsOptionsSelector(state),
    isLoading: selectors.formsIsLoadingSelector(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({ closeModalForm, onInput }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AdminModalForm);



// WEBPACK FOOTER //
// ./src/containers/admin/AdminModalForm.js